export default {
  title:               'Acordo das parcelas negociadas',
  bottom_message:      '<p>Caso não consiga visualizar as informações para pagamento, ou não tenha recebido, fale com a gente no Whatsapp: <strong>(11) 3335-2976</strong></p>',
  next_payment:        'Próxima parcela a vencer',
  installment_amount:  'Valor da parcela',
  date:                'Vencimento',
  paid_off:            'Pago',
  under_payment_plan:  'Em acordo',
  defaulted:           'Em atraso',
  pending:             'A vencer',
  view_boleto:         'Visualizar boleto',
  download_boleto:     'Download boleto',
  download_pix:        'Baixar QR Code PIX',
  copy_boleto_barcode: 'Copiar código de barras',
  copy_pix_barcode:    'Copiar código PIX',
  email:               'Enviar por email',
  copied:              'Copiado',
  emailed:             'Enviado',
  generic_error:       'Ops, algo deu errado, tente novamente ou fale com nosso atendimento',
  show_pdf_error:      'Realize a permissão do PopUp da página do Simplic',
};
